import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SidebarComponent } from "./sidebar.component";
import { ConfigsComponent } from "./new-sidebar/configs/configs.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { NewSidebarComponent } from "./new-sidebar/new-sidebar.component";
import { _MatMenuDirectivesModule } from "@angular/material/menu";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    MatCheckboxModule,
    MatSelectModule,
    _MatMenuDirectivesModule,
  ],
  declarations: [SidebarComponent, ConfigsComponent, NewSidebarComponent],
  exports: [NewSidebarComponent],
})
export class SidebarModule {}
